import { ContentTypes, UserContentBookmark } from '@/client/services/api/graphql/gql/graphql';

import BookmarkButton from '@/client/components/bookmarks/BookmarkButton';
import LearnerDashboardNoDataPlaceholder from '../components/LearnerDashboardNoDataPlaceholder';
import { Stack } from '@chakra-ui/react';
import StackedLearnerDashboardContentListItem from '@/client/components/learners/dashboard/components/lists/StackedLearnerDashboardContentListItem';
import { useBookmarkActions } from '@/client/components/bookmarks/useBookmarkActions';
import { useGetFormattedContentDuration } from '@/client/services/hooks/content/useGetContentDuration';
import { useLearnerDashboard } from '@/client/components/learners/dashboard/hooks/useLearnerDashboard';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function LearnerDashboardBookmarks() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getFormattedContentDuration } = useGetFormattedContentDuration();
  const { listUserBookmarks } = useBookmarkActions();
  const { contentTypeTranslationMap } = useLearnerDashboard();
  const { data: bookmarks } = listUserBookmarks();

  const handleRouteToContent = (bookmark: UserContentBookmark) => {
    const { content } = bookmark;
    const { contentType, id } = content;

    const routeByContentTypeMap: Partial<Record<ContentTypes, string>> = {
      [ContentTypes.Article]: '/article',
      [ContentTypes.Video]: '/video',
      [ContentTypes.Scorm]: '/scorm',
      [ContentTypes.ImportedContent]: '/imported-content',
      [ContentTypes.File]: '/file',
      [ContentTypes.Workshop]: '/workshop',
      [ContentTypes.Track]: '/track',
    };

    navigate(`${routeByContentTypeMap[contentType as ContentTypes]}/${id}`);
  };

  return (
    <>
      {bookmarks && bookmarks.edges.length === 0 && (
        <LearnerDashboardNoDataPlaceholder
          imagePath="/public/images/Knowledge-Base-2--Streamline-Brooklyn.svg"
          title={t('learners.dashboard.bookmarks.noData.title')}
          helpText={t('learners.dashboard.bookmarks.noData.helpText')}
          buttonData={{
            buttonCopy: t('learners.dashboard.toExplore'),
            buttonAction: () => navigate('/explore'),
          }}
        />
      )}

      {bookmarks && bookmarks.edges.length > 0 && (
        <Stack spacing={0}>
          {bookmarks.edges.map((bookmark) => {
            const { node } = bookmark;

            return (
              <StackedLearnerDashboardContentListItem
                key={node.id}
                id={node.content.id}
                imageUrl={node.content.thumbnail}
                formattedContentDuration={getFormattedContentDuration(node.content.duration)}
                onClick={() => handleRouteToContent(node)}
                title={node.content.title}
                contentType={contentTypeTranslationMap[node.content.contentType]}
                rightElement={
                  <BookmarkButton
                    contentId={node.content.id}
                    contentTitle={node.content.title}
                    contentType={node.content.contentType}
                  />
                }
              />
            );
          })}
        </Stack>
      )}
    </>
  );
}
